import BaseController from "niteroi/packages/system/controllers/Base.controller";
import {ILoadDataResponse} from "niteroi/packages/system/models/interfaces";

export default class Settings extends BaseController {
    public onInit(): void {
        super.onInit();
    }

    public onPressButtonSaveFormEdit(): void {
        const sessionModel = this.getModel("session");
        const companyId = sessionModel.getProperty("/company/companyId");
        const companyParentId = sessionModel.getProperty("/company/parentId");
        if (sessionModel.getProperty("/user/role") !== "super_admin" &&
            (companyParentId === null || companyId === companyParentId)
        ) {
            return;
        }

        this.getView().setBusyIndicatorDelay(0).setBusy(true);

        const settingsModel = this.getModel("settings");
        const url = "/api/settings";
        const data = settingsModel.getJSON();
        const headers = this.getRequestHeaders();
        settingsModel.loadData(url, data, true, "PUT", true, null, headers)
            .then()
            .catch((response: ILoadDataResponse) => {
                const responseText = JSON.parse(response.responseText);
                this.showToast(`${responseText.code} - ${responseText.error}`);
            })
            .finally(() => {
                this.getView().setBusy(false).setBusyIndicatorDelay(1000);
            });
    }
}
